import { render, staticRenderFns } from "./TopBrandIconsList.vue?vue&type=template&id=59c876f2&scoped=true&"
import script from "./TopBrandIconsList.vue?vue&type=script&lang=js&"
export * from "./TopBrandIconsList.vue?vue&type=script&lang=js&"
import style0 from "./TopBrandIconsList.vue?vue&type=style&index=0&id=59c876f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c876f2",
  null
  
)

export default component.exports